import { $Types } from '@Ravnur-Inc/core/typings/tsx';
import { RButton$Props } from '@Ravnur-Inc/core/ui-kit/button/button';
import { Prop } from '@Ravnur-Inc/decorators';
import { renderSlot, isVNode } from 'vue';
import { Vue, Options } from 'vue-class-component';

type Props = {
  text?: string;
  onCloseModal?: () => unknown;
};

@Options({
  emits: ['closeModal'],
})
export default class PopupButton extends Vue {
  declare $props: $Types<Props> & RButton$Props;
  @Prop({ type: String, default: '' }) public text!: string;

  private isShown = false;

  render() {
    return (
      <r-button {...this.$attrs} onclick={this.show}>
        {this.text}
        {this.renderModal()}
      </r-button>
    );
  }

  private renderModal() {
    if (this.isShown) {
      const content = renderSlot(this.$slots, 'default');
      if (content.children instanceof Array) {
        content.children.forEach((node) => {
          if (isVNode(node)) {
            node.props = node.props || {};
            const origin = node.props.close;
            node.props.close = () => {
              this.isShown = false;
              this.$emit('closeModal');
              if (typeof origin === 'function') {
                origin();
              }
            };
          }
        });
      }
      return content;
    }
  }

  private show() {
    this.isShown = true;
  }
}
